<template>
  <section>
    <label
      ><small v-show="leadOriginID.required" class="text-danger">*</small>
      Origem do Lead:</label
    >
    <div class="input-group">
      <b-form-select
        @change="onSelect()"
        :required="leadOriginID.required"
        v-model="leadOriginID.value"
        :options="leadOriginID.listOptions"
        placeholder="Selecione a origem"
        class="w-100"
        label="text"
      >
        <template v-slot:no-options>Nenhuma origem encontrada.</template>
      </b-form-select>
    </div>
  </section>
</template>

<script>
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'

export default {
  name: 'SelectOrigem',
  props: {
    selectedOption: {
      type: Number | String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      leadOriginID: { listOptions: [], value: null, required: true }
    }
  },
  created () {
    this.loadOrigins()
  },
  watch: {
    selectedOption: {
      immediate: true,
      handler: function (newVal) {
        this.leadOriginID.value = newVal
      }
    }
  },
  methods: {
    loadOrigins () {
      OriginRepository.GetAll()
        .then(res => {
          let sortedContent = res.data.content.sort(
            (a, b) => a.posicao - b.posicao
          )
          let options = sortedContent
            .filter(x => x.id != null)
            .map(x => ({ value: x.id, text: x.nome }))
          this.leadOriginID.listOptions = options
        })
        .catch(this.onException)
    },
    onSelect () {
      this.$emit('onSelect', this.leadOriginID.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/selects/SelectOrigem.vue